var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('HmdaHeader',{attrs:{"crumbs":_vm.breadcrumbs}}),_c('div',{staticClass:"body--wrapper mt-1 bg-white container"},[_c('ProjectsList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }